/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type DataRefreshEvent = typeof DataRefreshEvent[keyof typeof DataRefreshEvent];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataRefreshEvent = {
  AddressGeocodeCompleted: 'AddressGeocodeCompleted',
  BatchProcessCompleted: 'BatchProcessCompleted',
  BatchProcessCreated: 'BatchProcessCreated',
  BatchProcessItemCompleted: 'BatchProcessItemCompleted',
  BatchProcessItemDeferred: 'BatchProcessItemDeferred',
  BatchProcessItemRequeued: 'BatchProcessItemRequeued',
  BatchProcessItemStarted: 'BatchProcessItemStarted',
  DepositsPlanned: 'DepositsPlanned',
  FsmConnectionCacheCleared: 'FsmConnectionCacheCleared',
  FsmConnectionConnected: 'FsmConnectionConnected',
  FsmConnectionPreviewed: 'FsmConnectionPreviewed',
  FsmConnectionSyncStarted: 'FsmConnectionSyncStarted',
  FsmConnectionSynced: 'FsmConnectionSynced',
  FsmConnectionTechsSynced: 'FsmConnectionTechsSynced',
  FsmTechInvited: 'FsmTechInvited',
  GpsCaptured: 'GpsCaptured',
  GpsDeleted: 'GpsDeleted',
  IdentityVerificationStatusChanged: 'IdentityVerificationStatusChanged',
  InvitationAccepted: 'InvitationAccepted',
  InvitationCreated: 'InvitationCreated',
  JoinRequestApproved: 'JoinRequestApproved',
  JoinRequestCreated: 'JoinRequestCreated',
  NotificationsChanged: 'NotificationsChanged',
  OpportunityClaimPayoutOverdue: 'OpportunityClaimPayoutOverdue',
  OpportunityClaimPayoutRequestApproved: 'OpportunityClaimPayoutRequestApproved',
  OpportunityClaimPayoutRequestDenied: 'OpportunityClaimPayoutRequestDenied',
  OpportunityClaimPayoutRequestPaid: 'OpportunityClaimPayoutRequestPaid',
  OpportunityClaimPayoutRequestReturned: 'OpportunityClaimPayoutRequestReturned',
  OpportunityClaimPayoutRequestSubmitted: 'OpportunityClaimPayoutRequestSubmitted',
  OpportunityClaimPayoutRetried: 'OpportunityClaimPayoutRetried',
  OpportunityClaimPayoutTerminallyFailed: 'OpportunityClaimPayoutTerminallyFailed',
  OpportunityClaimPayoutVoided: 'OpportunityClaimPayoutVoided',
  OpportunityClaimed: 'OpportunityClaimed',
  OpportunityCreated: 'OpportunityCreated',
  OpportunityShared: 'OpportunityShared',
  OrganizationAuthorizedByPaymentProvider: 'OrganizationAuthorizedByPaymentProvider',
  OrganizationBankAccountLinked: 'OrganizationBankAccountLinked',
  OrganizationBankAccountRemoved: 'OrganizationBankAccountRemoved',
  OrganizationDepositAborted: 'OrganizationDepositAborted',
  OrganizationDepositInitiated: 'OrganizationDepositInitiated',
  OrganizationFundingCompleted: 'OrganizationFundingCompleted',
  OrganizationFundingFailed: 'OrganizationFundingFailed',
  OrganizationKybApproved: 'OrganizationKybApproved',
  OrganizationPaymentDestinationDesignated: 'OrganizationPaymentDestinationDesignated',
  PayoutCreated: 'PayoutCreated',
  PayoutOverdue: 'PayoutOverdue',
  PayoutReleased: 'PayoutReleased',
  PayoutRequestAllocated: 'PayoutRequestAllocated',
  PayoutRequestApproved: 'PayoutRequestApproved',
  PayoutRequestDenied: 'PayoutRequestDenied',
  PayoutRequestEdited: 'PayoutRequestEdited',
  PayoutRequestGenerated: 'PayoutRequestGenerated',
  PayoutRequestPaid: 'PayoutRequestPaid',
  PayoutRequestResubmitted: 'PayoutRequestResubmitted',
  PayoutRequestReturned: 'PayoutRequestReturned',
  PayoutRequestSubmitted: 'PayoutRequestSubmitted',
  PayoutRetried: 'PayoutRetried',
  PayoutTerminallyFailed: 'PayoutTerminallyFailed',
  PayoutVoided: 'PayoutVoided',
  ReferralCreated: 'ReferralCreated',
  ReferralInvited: 'ReferralInvited',
  StaffMemberJoined: 'StaffMemberJoined',
  TalentMemberJoined: 'TalentMemberJoined',
} as const;
